<template>
  <div>
    <div class="chart-header">
      <span class="chart-title">{{ title }}</span>
    </div>
    <p class="chart-subtitle" style="margin-top: 20px" v-if="text">{{ text }}</p>
    <p class="chart-text" style="text-align: left" v-if="subtext">
      {{ subtext }}
    </p>

    <div class="chart-legend" v-if="legends">
      <CustomLegend
        v-for="legend in legends"
        :key="legend.text"
        :color="legend.color"
        :text="legend.text"
      />
    </div>
    <canvas :id="chartId" :style="styleChart"></canvas>
  </div>
</template>

<script>
import CustomLegend from '@/Shared/Charts/CustomLegend'
import { Chart, registerables } from 'chart.js'
import moment from 'moment'

Chart.register(...registerables)

export default {
  name: 'HotelOccupancyChart',
  components: {
    CustomLegend,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: false,
    },
    subtext: {
      type: String,
      required: false,
    },
    chartType: {
      type: String,
      default: 'bar',
    },
    legends: {
      type: Array,
      required: false,
    },
    dataSets: {
      type: Array,
      required: true,
    },
    chartId: {
      type: String,
      required: true,
    },
    indexAxis: {
      type: String,
      required: false,
      default: 'x',
    },
    styleChart: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      chart: null,
    }
  },
  mounted() {
    this.createChart()
  },
  methods: {
    createChart() {
      if (this.chart) {
        this.chart.destroy()
      }

      let datasets = []
      let labels = []

      this.dataSets.forEach((dataSet) => {
        const data = this.processData(dataSet.answers)
        labels = [...new Set([...labels, ...data.map((d) => d.date)])].sort()
        const dataset = this.buildDataset(data, labels, dataSet.label, dataSet.color, dataSet.color)
        datasets.push(dataset)
      })

      const ctx = document.getElementById(this.chartId).getContext('2d')
      this.chart = new Chart(ctx, {
        type: this.chartType,
        data: {
          labels,
          datasets,
        },
        options: {
          indexAxis: this.indexAxis,
          responsive: true,
          maintainAspectRatio: true,
          spanGaps: true,
          elements: {
            line: {
              tension: 0.4,
            },
            point: {
              radius: 3,
              hoverRadius: 6,
              hitRadius: 10,
            },
          },
          plugins: {
            legend: { display: false },
            title: { display: true },
            tooltip: {
              enabled: true,
              mode: 'nearest',
              intersect: true,
              callbacks: {
                label: function (context) {
                  return `${context.dataset.data[context.dataIndex]}%`
                },
              },
            },
          },
          interaction: {
            intersect: false,
          },
          scales: {
            x: {
              display: true,
              title: {
                display: true,
              },
            },
            y: {
              display: true,
              title: {
                display: true,
              },
            },
          },
        },
      })
    },
    processData(answers) {
      return answers.map((answer) => ({
        date: moment(answer.answer_date).format('MM-YYYY'),
        value: parseFloat(answer.answer_text),
      }))
    },
    buildDataset(data, labels, label, borderColor, backgroundColor) {
      const dataset = labels.map((label) => {
        const found = data.find((d) => d.date === label)
        return found ? found.value : 0
      })

      return {
        label,
        data: dataset,
        borderColor,
        backgroundColor,
        fill: false,
      }
    },
  },
}
</script>

<style src="./styles.css">
</style>
